export const BUILD_INFO = {
  "app": "lottotracker",
  "version": "e0adbfd14522-1793538533500",
  "gitSha": "e0adbfd1452230d60d8117f9cd813db6b3a3333d",
  "builtAt": "2026-11-01T13:08:53.500Z"
};
export default BUILD_INFO;
